import React, { useEffect, useState } from 'react'
import SubirImagenes from './SubirImagenes/SubirImagenes'
import axios from 'axios'
import {
    MDBModal,
    MDBModalBody,
    MDBModalHeader
} from 'mdbreact';

const SubirImagenesContainer = ({ imagenActual, modal, modificarModal }) => {

    const baseUrl = process.env.REACT_APP_BASE_URL
    const api = process.env.REACT_APP_API
    const urlImagenes = baseUrl + api + 'imagenes/'

    const [imagenes, setImagenes] = useState([])

    useEffect(() => {
        buscarImagenes()
    }, [])


    const buscarImagenes = async () => {
        try {
            const { data: respuesta } = await axios(urlImagenes);
            if (!respuesta) {
                return setImagenes([])
            }
            const itemsImagen = []
            respuesta.map(imagen => {
                itemsImagen.push({
                    id: imagen.id,
                    data_url: urlImagenes + imagen.ruta,
                    path: imagen.ruta
                })
            })

            setImagenes(itemsImagen)

        } catch (error) {
            console.log(error)
        }
    }
    const eliminarImagen = async (id, path) => {
        try {
            let formData = new FormData()
            formData.append(`METHOD`, 'DELETE')
            await axios.post(urlImagenes, formData, { params: { id, path } })
            buscarImagenes()
        } catch (error) {
            console.log(error)
        }
    }

    const imagenSeleccionada = (img) => {
        imagenActual(img[0])
    }

    const subirImagenes = async (files) => {
        try {
            let formData = new FormData()

            for (let i = 0; i < files.length; i++) {
                formData.append(`images[${i}]`, files[i].file)
            }
            formData.append(`METHOD`, 'POST')
            const headers = { headers: { "Content-Type": "multipart/form-data", }, };
            await axios.post(urlImagenes, formData, headers)
            buscarImagenes()
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <MDBModal isOpen={modal} toggle={modificarModal} size="lg"  >
            <MDBModalHeader toggle={modificarModal}>Imagenes</MDBModalHeader>
            <MDBModalBody>
                <SubirImagenes dataSources={imagenes} onRemove={eliminarImagen} onSelect={imagenSeleccionada} onUpload={subirImagenes} />
            </MDBModalBody>
        </MDBModal>
    )
}

export default SubirImagenesContainer